export const MOBILE_SIDEBAR_HEIHGT = 64
export const MOBILE_TIMELINE_ROW_HEIGHT = 48
